import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import StickyAnchorAd from "./components/StickyAnchorAd";
import { SavedProvider } from "./context/SavedContext";
import { AdminAuthProvider } from "./context/AdminAuthContext";
import { MonetizationProvider } from "./context/MonetizationContext";
import Home from "./pages/Home";
import Emirates from "./pages/Emirates";
import EmirateDetail from "./pages/EmirateDetail";
import Visas from "./pages/Visas";
import HotelDetail from './pages/HotelDetail';
import Hotels from "./pages/Hotels";
import Deals from "./pages/Deals";
import Living from "./pages/Living";
import Culture from "./pages/Culture";
import GuidePage from "./pages/GuidePage";
import About from "./pages/About";
import Planner from "./pages/Planner";
import SharedPlanner from "./pages/SharedPlanner";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

function Shell() {
  const location = useLocation();
  const ADMIN_BASE = process.env.REACT_APP_ADMIN_PATH || "/admin";
  const isAdmin = location.pathname.startsWith(ADMIN_BASE);
  return (
    <>
      <ScrollToTop />
      {!isAdmin && <Navbar />}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/emirates" element={<Emirates />} />
          <Route path="/emirates/:slug" element={<EmirateDetail />} />
          <Route path="/visas-entry" element={<Visas />} />
          <Route path="/hotels" element={<Hotels />} />
            <Route path="/hotels/:slug" element={<HotelDetail />} />
          <Route path="/deals" element={<Deals />} />
          <Route path="/living" element={<Living />} />
          <Route path="/culture-customs" element={<Culture />} />
          <Route path="/property" element={<GuidePage which="property" />} />
          <Route path="/business" element={<GuidePage which="business" />} />
          <Route path="/planner" element={<Planner />} />
          <Route path="/shared/:sid" element={<SharedPlanner />} />
          <Route path={`${ADMIN_BASE}/login`} element={<AdminLogin />} />
          <Route path={ADMIN_BASE} element={<AdminDashboard />} />
          <Route path="/admin/*" element={<NotFoundSilent />} />
          <Route path="/about" element={<About />} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
      {!isAdmin && <StickyAnchorAd />}
    </>
  );
}

const NotFoundSilent = () => <div className="min-h-[60vh] flex items-center justify-center text-[#6B6F78]">Page not found.</div>;

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AdminAuthProvider>
          <MonetizationProvider>
            <SavedProvider>
              <Shell />
            </SavedProvider>
          </MonetizationProvider>
        </AdminAuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
